/* eslint react/jsx-filename-extension: 0 */
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Playlists from './Playlists';
import PlaylistEpisodes from './PlaylistEpisodes';
import Video from './Video';
import Programs from './Programs';
import About from './About';
import NotFound from './NotFound';

const Routes = props => (
  <Switch>
    <Route exact path="/" render={() => <Redirect to="series" />} />
    <Route
      exact
      path="/series"
      render={subProps => <Playlists {...props} {...subProps} />}
    />
    <Route
      path="/series/:id"
      render={subProps => <PlaylistEpisodes {...props} {...subProps} />}
    />
    <Route
      path="/video/:id"
      render={subProps => <Video {...props} {...subProps} />}
    />
    <Route
      exact
      path="/programs"
      render={subProps => <Programs {...props} {...subProps} />}
    />
    <Route
      exact
      path="/about"
      render={subProps => <About {...props} {...subProps} />}
    />
    <Route path="*" component={NotFound} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/Routes.js